const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const GlobalSmsRateLimitCommand: any = {
    InsertRateLimit: Backofficebff + '/v1/globalsmsratelimit/insert-rate-limit',
};

